"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const occupancyfilled = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-occupancyfilled` : '') + (description ? ` desc-occupancyfilled` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-occupancyfilled"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-occupancyfilled"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 12.75C17.799 12.75 22.5 17.451 22.5 23.25C22.5 23.6642 22.1642 24 21.75 24H2.25C1.83579 24 1.5 23.6642 1.5 23.25C1.5 17.451 6.20101 12.75 12 12.75ZM12 0C15.3137 0 18 2.68629 18 6C18 9.31371 15.3137 12 12 12C8.68629 12 6 9.31371 6 6C6 2.68629 8.68629 0 12 0Z",
    fill: "inherit"
  }));
};
var _default = exports.default = occupancyfilled;